import { createClassName } from 'utils/createClassName';

import './smallTableStyles.scss';

export const createSmallTableClassName = createClassName('smallTable');
